import script from "./TopicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicPage.vue?vue&type=script&setup=true&lang=js"

import "./TopicPage.vue?vue&type=style&index=0&id=369fe463&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369fe463"]])

export default __exports__